import { AddContentRouter } from "../views/unity/add-content/router/add-content-router";
import { SimpleAuthRouter } from "../views/common/auth/router/simple-router";
import { ContentLibraryRouter } from "../views/unity/content-library/router/content-library-router";
import { RequisitionRouter } from "../views/unity/requisition/router/requisition-router";
import { DefaultRouter } from "./default-router";
import { SimpleRouter } from "./simple-router";
import { UserManagementRouter } from "../views/settings/user-management/router/user-management-router";
import { VendorManagementRouter } from "../views/settings/vendor-management/router/vendor-management-router";
import { RoleManagementRouter } from "../views/settings/role-management/router/role-management-router";
import { ActionTypeRouter } from "../views/settings/master-management/action-type-management/router/actiontype-management-router";
import { PriorityRouter } from "../views/settings/master-management/priority-management/router/priority-router";
import { MenuManagement } from "../views/settings/master-management/menu-management/router/menu-management-router";
import { SpecialityManagementRouter } from "../views/settings/master-management/speciality-management/router/speciality-management-router";
import { CouncilRouter } from "../views/settings/master-management/council-management/router/council-router";
import { CountryRouter } from "../views/settings/master-management/country-management/router/country-router";
import { CityRouter } from "../views/settings/master-management/city-management/router/city-router";
import { ZoneRouter } from "../views/settings/master-management/zone-management/router/zone-router";
import { StateRouter } from "../views/settings/master-management/state-management/router/state-router";
import { AssociationRouter } from "../views/settings/master-management/association-manage/router/association-router";
import { DeparmentManagementRouter } from "../views/settings/master-management/deparment-management/router/deparment-router";
import { TargetManagementRouter } from "../views/settings/master-management/target-management/router/target-source-router";
import { ContentCategoryRouter } from "../views/settings/master-management/content-category-management/router/content-category-router";
import { ClientRouter } from "../views/settings/master-management/client-management.js/router/client-router";
import { PrincipleEntityManagementRouter } from "../views/settings/master-management/principle-entity-management.js/router/principle-entity-router";
import { FileTypeManagementRouter } from "../views/settings/master-management/file-type-management/router/file-type-router";
import { HCP_ProfileRouter } from "../views/engage/hcp-profile/router/hcp-profile-router";
import { NotificationRouter } from "../views/engage/notifications/router/notification-router";
import { OnboardingRouter } from "../views/engage/onboarding/router/onboarding-router";
import { ShortLinkRouter } from "../views/engage/short-link/router/short-link-router";
import { EngagementRouter } from "../views/engage/engagement/router/engagement-router";
import { EmbeddedToolsRouter } from "../views/engage/embedded-tools/router/embedded-tools-router";
import { SegmentRouter } from "../views/engage/campaign-segments/router/segment-router";
import { ActionRouter } from "../views/common/action/router/action-router";
import { CampaignRouter } from "../views/engage/campaign/router/campaign-router";
import { TemplateManagerRouter } from "../views/engage/template-manager/router/template-manager-router";
import { CreativeLibraryRouter } from "../views/engage/creative-library/router/creative-library-router";
import { HelpAndSupportRouter } from "../views/common/help-and-support/router/help-and-support-router";
import { WorkspaceRouter } from "../views/workspace/router/workspace-router";
import { UserProfileRouter } from "../views/common/user-profile/router/user-profile-router";
import { ContentStudioRouter } from "../views/engage/content-studio/router/content-studio-router";
export const IndexRouters = [
  ...DefaultRouter,
  ...SimpleRouter,
  ...SimpleAuthRouter,
  ...ContentLibraryRouter,
  ...AddContentRouter,
  ...RequisitionRouter,
  ...ActionRouter,
  ...UserManagementRouter,
  ...VendorManagementRouter,
  ...RoleManagementRouter,
  ...ActionTypeRouter,
  ...PriorityRouter,
  ...MenuManagement,
  ...SpecialityManagementRouter,
  ...CouncilRouter,
  ...CountryRouter,
  ...CityRouter,
  ...StateRouter,
  ...ZoneRouter,
  ...AssociationRouter,
  ...DeparmentManagementRouter,
  ...TargetManagementRouter,
  ...FileTypeManagementRouter,
  ...ContentCategoryRouter,
  ...ClientRouter,
  ...PrincipleEntityManagementRouter,
  ...HCP_ProfileRouter,
  ...NotificationRouter,
  ...OnboardingRouter,
  ...ShortLinkRouter,
  ...EngagementRouter,
  ...EmbeddedToolsRouter,
  ...SegmentRouter,
  ...ContentStudioRouter,
  ...CampaignRouter,
  ...TemplateManagerRouter,
  ...CreativeLibraryRouter,
  ...HelpAndSupportRouter,
  ...WorkspaceRouter,
  ...UserProfileRouter,
];
